/**
 * @desc 分页
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.warehouseCost.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/warehouseCost/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
